module.exports = __webpack_public_path__ + "static/media/studio-pro-step2@3x.bec631dd.webp";